import styled from 'styled-components';

export const GreenroadDriveStyled = styled.div`
  position: relative;
  margin: 0;
  background-color: #ffffff;

  padding-bottom: 8px;
`;
